import { getPathString, isObjectValueType } from '@helpers'
import { BIND_TYPE, EXPAND_FIELD_PREFIX, FIELD_VALUE_TYPE } from '@constants'
import { MainObjectTypeEnum, TimeLineDTOType } from '@types'

export const getExpandsParamForObjectY = (config: TimeLineDTOType) => {
  const yColumns = config.objectY.columns || []
  const { mainObject } = config

  const expands: string[] = []

  if (mainObject?.objectType === MainObjectTypeEnum.Y && mainObject.groupField?.length) {
    const pathsForExpand = (
      mainObject.groupTitleDisplayField?.length
        ? mainObject.groupTitleDisplayField
        : mainObject?.groupField || []
    ).filter(item => isObjectValueType(item.valueType))

    if (pathsForExpand.length) {
      expands.push(
        `${getPathString(pathsForExpand)}:${getPathString(pathsForExpand, EXPAND_FIELD_PREFIX)}`
      )
    }
  }

  yColumns.forEach(item => {
    const valuePaths = item.pathArray

    if (valuePaths?.length && item.bindType === BIND_TYPE.FIELD) {
      /* ref_1.ref_2:expands_ref1.expands_ref2 поле expands в командах раскрывает ссылочные поля ref_1.ref_2 и кладет их в expands_ref1.expands_ref2,
       последнее значение обрезается, т.к. это не ссылка, а поле, которое нужно отобразить */
      const pathsForExpand = valuePaths.slice(0, -1)
      pathsForExpand.unshift({
        field: item.value,
        valueType: item.valueType as FIELD_VALUE_TYPE,
        objectCode: item.objectCode || '',
        refValueType: item.valueType as FIELD_VALUE_TYPE,
      })

      expands.push(
        `${getPathString(pathsForExpand)}:${getPathString(pathsForExpand, EXPAND_FIELD_PREFIX)}`
      )
    }
  })

  return expands
}

export const getExpandsParamForObjectX = (config: TimeLineDTOType) => {
  const linkToObjectY = config.objectX.linkToObjectY
  const { mainObject } = config

  const expands: string[] = []

  if (linkToObjectY?.length > 1) {
    const pathsForExpand = linkToObjectY.slice(0, -1)

    expands.push(
      `${getPathString(pathsForExpand)}:${getPathString(pathsForExpand, EXPAND_FIELD_PREFIX)}`
    )
  }

  if (mainObject?.objectType === MainObjectTypeEnum.X && mainObject?.groupField?.length) {
    const pathsForExpand = (
      mainObject.groupTitleDisplayField?.length
        ? mainObject.groupTitleDisplayField
        : mainObject?.groupField || []
    ).filter(item => isObjectValueType(item.valueType))

    if (pathsForExpand.length) {
      expands.push(
        `${getPathString(pathsForExpand)}:${getPathString(pathsForExpand, EXPAND_FIELD_PREFIX)}`
      )
    }
  }

  return expands
}
